<template>
  <v-app class="container">
    <v-content>
      <barra />
      <v-card>
        <v-card-title v-if="!gestrategias" class="grey lighten-4 change-font" primary-title>
          <div class="spinner-grow"></div>Cargando estrategias &#8230;
        </v-card-title>
        <v-card-title
          v-else
          class="grey lighten-4 change-font"
          primary-title
        >Avance de indicadores por estrategia</v-card-title>
        <v-card-text>
          <v-container v-if="punto">
            <v-layout wrap>
              <v-flex md2 class="d-none d-md-block">
                <img
                  width="120px"
                  class="mx-auto d-block gray"
                  v-bind:src="'data:image/jpeg;base64,' + punto.icono"
                />
              </v-flex>
              <v-flex md10>
                <v-layout>
                  <v-menu
                    :open-on-hover="false"
                    :close-on-content-click="true"
                    :offset-x="false"
                    :offset-y="false"
                  >
                    <template v-slot:activator="{ on }">
                      <div class="content-title" :style="{ color: punto.color }">
                        {{ punto.nombre }}
                        <v-btn text icon v-on="on">
                          <v-icon>icon-list</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(item, index) in gpuntos"
                        :key="index"
                        @click="seleccionarpunto(item)"
                      >
                        <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-layout>
                <v-layout justify-center class="d-none d-md-block">{{ punto.descripcion }}</v-layout>
              </v-flex>
            </v-layout>
            <v-select
              :clearable="false"
              :searchable="false"
              :filterable="false"
              label="Pilar:"
              item-text="nombrecompleto"
              value="idpilar"
              :items="pilares"
              v-model="pilar"
              return-object
              style="min-width:400px"
            ></v-select>
            <v-select
              :clearable="false"
              :searchable="false"
              :filterable="false"
              label="Estrategia:"
              item-text="nombrecompleto"
              item-value="idestrategia"
              value="idestrategia"
              :items="gestrategias"
              return-object
              v-model="estrategia"
              style="min-width:400px"
            ></v-select>
            <div v-if="gindicadores">
              <v-data-table
                :no-data-text="gnodata"
                :headers="headers"
                :items="gindicadores"
                class="elevation-2"
                hide-default
                :items-per-page="10"
              >
                <template v-slot:item.action="{ item }">
                  <div v-if="item.finalizado === true">
                    <v-icon small class="mr-2" @click="verdetalle(item)">remove_red_eye</v-icon>
                  </div>
                  <div v-else>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon small color="red" class="mr-2" v-on="on">remove_red_eye</v-icon>
                      </template>
                      <span>Sin ficha técnica</span>
                    </v-tooltip>
                  </div>
                </template>
                <template v-slot:item.avancemostrar="{ item }">
                  <div v-if="item.avancemostrar !== '-'">
                    <span small class="mr-2">{{item.avancemostrar}}</span>
                  </div>
                  <div v-else>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on" class="mr-2">{{item.avancemostrar}}</span>
                      </template>
                      <span>Entidad no registró avance</span>
                    </v-tooltip>
                  </div>
                </template>
                <template v-slot:footer>
                  <div id="div1" style="width:100%;align:right">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <download-excel
                          id="div2"
                          style="width:100%;text-align: right;"
                          v-show="gindicadores.length>0"
                          class="btn btn-default"
                          :data="gindicadores"
                          :exportFields="exportable"
                          name="indicadores.xls"
                          type="xls"
                          worksheet="Información"
                        >
                          <v-icon
                            color="secondary"
                            v-on="on"
                            large
                            elevation="2"
                          >mdi-file-download-outline</v-icon>
                        </download-excel>
                      </template>
                      <span>Descargar</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import barra from "@/components/content/barra-nav.vue";

export default {
  name: "estrategia",
  components: {
    barra
  },
  data: function() {
    return {
      exportable: {
        Código: "codigo",
        Nombre: "nombre",
        "Descripción" : "descripcion",
        Entidad: "entidades.nombre",
        "Ficha técnica": {
          field: "finalizado",
          callback: value => {
            if (value) return "Sí";
            else return "No";
          }
        },
        Avance: "avancemostrar",
        Inicio: "inicio",
        Fin: "fin"
      },
      periodoId: 0,
      fuente: "gestrategias",
      pilar: null,
      punto: null,
      estrategia: null,
      color: "",
      pilares: [],
      puntos: [],
      items: [],
      item: 0,
      values: [],
      headers: [
        { text: "Código", value: "codigo", fixed: true, width: "100px" },
        { value: "nombre", text: "Nombre" },
        { value: "entidades.nombre", text: "Responsable", width: "30%" },
        {
          value: "avancemostrar",
          align: "right",
          text: "Avance",
          width: "110px"
        },
        { text: "Detalle", value: "action", sortable: false, align: "center" }
      ],

    };
  },
  beforeUpdate() {},
  updated() {},
  created() {
    this.pilares = this.gpilares;
    this.puntos = this.gpuntos;
    if (this.puntos === null) {
      this.cargarpuntos();
    } else {
      this.punto = this.puntos.filter(
        record => record.idpunto == this.$route.params.idpunto
      )[0];
      this.pilar = this.pilares.filter(
        record => record.idpilar == this.$route.params.idpilar
      )[0];
      this.cargarestrategiaspilar();
    }
  },
  mounted() {},
  computed: {
    ...mapGetters([
      "gpilares",
      "gpuntos",
      "gestrategias",
      "glineas",
      "gproductos",
      "gindicadores"
    ]),
    ...mapGetters("barra", ["gperiodo"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    totalChilds() {
      var t = 0;
      this.gestrategias
        .filter(p => p.avance !== 0)
        .forEach(element => {
          t += element.indicadores;
        });
      return t;
    },
    total() {
      return this.gestrategias.filter(p => p.avance !== 0).length;
    },
    itemsporpagina() {      
      if ( !isNaN( this.itemsPerPageSopCuan )) return this.itemsPerPageSopCuan;
      else return 1;
    }
  },
  methods: {
    ...mapActions([
      "get_pilarespunto",
      "get_estrategiaspilar",
      "get_lineaspilar",
      "get_productospilar",
      "get_indicadoresestrategia",
      "get_indicadoreslinea",
      "get_indicadoresproducto",
      "get_indicadorespilar",
      "puntoTodos"
    ]),
    cargarpuntos() {
      this.puntoTodos({
        params: {
          periodoId: this.gperiodo
        }
      });
    },
    cargarpilarespunto() {
      this.get_pilarespunto({
        params: { idpunto: this.punto.idpunto, idperiodo: this.gperiodo },
        data: {}
      });
    },
    verdetalle(item) {
      let global = JSON.parse(unescape(process.env.PACKAGE_JSON)).global;
      let env = global[global.env];
      this.$aes.setKey(env.path.secret);
      let cifra = this.$aes.encrypt(item.idindicador.toString());
      let temporal =
        Math.random()
          .toString(36)
          .substring(2, 6) +
        cifra +
        Math.random()
          .toString(36)
          .substring(2, 6);
      let encrypted = this.$aes.encrypt(temporal);
      encrypted = encrypted.replace(/\//g, "AbcYq");
      encrypted = encrypted.replace(/\+/g, "qYcbA");
      this.$router.push("/detalleindicador/" + encrypted);
    },
    cargarestrategiaspilar() {
      this.get_estrategiaspilar({
        params: { idpilar: this.pilar.idpilar },
        data: {}
      });
    },
    cargarindicadores(data) {
      if (data.id !== 0) {
        this.get_indicadoresestrategia({
          params: {
            idestrategia: data.id,
            idperiodo: this.gperiodo
          },
          data: {}
        });
      } else {
        this.get_indicadorespilar({
          params: {
            idpilar: this.pilar.idpilar,
            idperiodo: this.gperiodo
          },
          data: {}
        });
      }
    },
    seleccionarpunto(b) {
      this.punto = b;
    }
  },
  watch: {
    pilar: function() {
      this.cargarestrategiaspilar();
    },
    punto: function() {
      this.cargarpilarespunto();
    },
    gpuntos: function() {
      this.puntos = this.gpuntos;
      this.punto = this.puntos.filter(
        record => record.idpunto == this.$route.params.idpunto
      )[0];
      this.cargarpilarespunto();
    },
    gpilares: function() {
      this.pilares = this.gpilares;
      let temp = this.pilares.filter(
        record => record.idpilar == this.$route.params.idpilar
      )[0];
      if (temp === undefined) {
        temp = this.pilares[0];
      }
      this.pilar = temp;
    },
    gestrategias: function() {
      this.estrategia = this.gestrategias[0];
    },
    estrategia: function() {
      let data = { id: this.estrategia.idestrategia };
      this.cargarindicadores(data);
    },
    gperiodo: function() {
      if (this.estrategia !== undefined) {
        let data = { id: this.estrategia.idestrategia };
        this.cargarindicadores(data);
      }
    }
  }
};
</script>
